import { useAuthIsLoaded } from '@/hooks/useAuthIsLoaded';
import {
  SocialMediaSettings,
  useGetSocialMediaSettingsQuery,
} from '@/store/socialSettingsApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import QuickLinkUtility from './quick-link.utility';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import { SvgIconProps } from '@mui/material';

type SocialPlatformKey = keyof SocialMediaSettings;

interface SocialLinkConfig {
  key: SocialPlatformKey;
  Icon: React.ComponentType<SvgIconProps>;
  label: string;
}

export const useSocialLinks = () => {
  const authLoaded = useAuthIsLoaded();

  // Fetch social media settings from dashboardSidePanels (investor-social panel)
  const { data: socialMediaSettings } = useGetSocialMediaSettingsQuery(
    authLoaded ? undefined : skipToken,
  );

  const activeSocialLinks = useMemo(() => {
    if (!socialMediaSettings) return [];

    const SOCIAL_LINK_CONFIGS: SocialLinkConfig[] = [
      { key: 'Facebook', Icon: FacebookRoundedIcon, label: 'Facebook' },
      { key: 'LinkedIn', Icon: LinkedInIcon, label: 'LinkedIn' },
      { key: 'Twitter', Icon: XIcon, label: 'Twitter' },
      { key: 'Instagram', Icon: InstagramIcon, label: 'Instagram' },
    ];

    return SOCIAL_LINK_CONFIGS.map((config) => ({
      ...config,
      url: QuickLinkUtility.normalizeUrl(socialMediaSettings[config.key]),
    })).filter((link) => link.url);
  }, [socialMediaSettings]);

  return { activeSocialLinks };
};
